import FollowerOrgLogo from "%/dynamic-component-editor/standard-components/follower-card/FollowerOrgLogo.vue";
import FollowerOrgName from "%/dynamic-component-editor/standard-components/follower-card/FollowerOrgName.vue";
import FollowButton from "%/dynamic-component-editor/standard-components/follower-card/FollowButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyFollower extends LegacyEntity {
  get elements() {
    return {
      FollowerOrgLogo,
      FollowerOrgName,
      FollowButton,
    };
  }
}
